import type { CalendarViewer } from '@repo/common/types/Viewer';
import { DEFAULT_CALENDAR_VIEWER as _DEFAULT_CALENDAR_VIEWER } from '@repo/common/types/Viewer';
import { type Writable, writable } from 'svelte/store';
import constants from '../utils/constants';
import { createResetter, createUpdater } from '../utils/simpleStore.util';

const DEFAULT_CALENDAR_VIEWER: CalendarViewer = {
  ..._DEFAULT_CALENDAR_VIEWER,
  timeGrain: ['macos', 'windows', 'desktop'].includes(constants.PLATFORM) ? 'week' : 'day'
};

export const calendarViewerStore: Writable<CalendarViewer> = writable(DEFAULT_CALENDAR_VIEWER);

export const updateCalendarViewer = createUpdater(calendarViewerStore, DEFAULT_CALENDAR_VIEWER);

export const setCalendarViewer = calendarViewerStore.set;

export const resetCalendarViewer = createResetter(calendarViewerStore, DEFAULT_CALENDAR_VIEWER);
